import {goTo} from '@utils';
import checkinIcon from '@assets/icons/home/check-in.png';
import React from 'react';
import {useLogin} from '@utils/state-hooks';
import {useRequest} from 'ahooks';
import {getSignDataPromotion} from '@/pages/promotions/service';

export default function HomeSideCheck() {
  const login = useLogin();
  const {data: signPromotion} = useRequest(() => getSignDataPromotion(), {
    ready: login,
  });
  return signPromotion ? (
    <div
      className="size-16 bg-full"
      onClick={() => {
        goTo('CheckIn');
      }}
      style={{
        backgroundImage: `url(${checkinIcon})`,
      }}></div>
  ) : null;
}
